<page-header>
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="page-title mb-1">{ props.title }</h2>
        <p if={ props.subtitle } class="text-muted mb-0">{ props.subtitle }</p>
      </div>
      <div class="page-header-actions d-flex gap-2">
        <!-- Botón Volver (mostrar solo si onback está definido) -->
        <button
          if={ props.onback }
          type="button"
          class="btn btn-outline-secondary app-btn app-btn-md"
          onclick={ handleBack }>
          <i class="bi bi-arrow-left me-1"></i> Volver
        </button>

        <!-- Botones personalizados adicionales mediante slot -->
        <slot name="actions"></slot>
      </div>
    </div>
  </div>

  <script>
    export default {
      handleBack(e) {
        if (this.props.onback) {
          this.props.onback(e);
        }
      }
    }
  </script>

  <style>
    .page-header {
      border-bottom: 1px solid #dee2e6;
      padding-bottom: 1rem;
    }

    .page-title {
      font-size: 1.75rem;
      font-weight: 600;
      color: #212529;
    }

    .page-header-actions {
      flex-shrink: 0;
    }

    @media (max-width: 768px) {
      .page-header .d-flex {
        flex-direction: column;
        align-items: flex-start !important;
      }

      .page-header-actions {
        margin-top: 1rem;
        width: 100%;
      }

      .page-title {
        font-size: 1.5rem;
      }
    }
  </style>
</page-header>
